import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";
import { useRecoilState } from "recoil";
import { usePostHog } from 'posthog-js/react';

import { handleAndTrackError, isValidPhone, trackBtnClick, trackError } from "@/lib/helper";
import { onboardingFormDataAtom } from "@/recoil/atom/onboardingFormDataAtom";
import DynamicInputForm from "@/components/common/DynamicInputForm.jsx";
import PrimaryButton from "@/components/common/buttons/PrimaryButton.jsx";
import GoBackButton from "@/components/common/buttons/GoBackButton";
import { sendOtpV2, signUpV2, verifyOtp, trackConsent } from "@/lib/apis";
import { headingVariants } from "@/lib/data";
import config from "@/config";
import { motion } from "framer-motion";
import OTPInput from "react-otp-input";
import Loader from "../common/Loader";
import CustomDrawer from "../common/drawer";
import Header from "@/components/common/Header/header";
import { ChevronLeftIcon } from "lucide-react";
import RedirectPage from "@/components/onboarding/RedirectPage";

import TextField from "@/components/common/Input/TextField.jsx";

const formConfig = [
  {
    type: "tel",
    label: "Phone",
    name: "phone",
    required: true,
  },
  // {
  //   type: "text",
  //   label: "ReferralCode (Optional)",
  //   name: "referralCode",
  //   required: false,
  // },
];

const CONSENT_MESSAGE =
  "I hereby agree to CirclePe's T&Cs and Privacy Policy & consent to be contacted by CirclePe and its partners via WhatsApp, etc.";

export default function SignUp() {
  const posthog = usePostHog();
  const navigate = useNavigate();

  const [newUser, setNewUser] = useState(true);
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [otpDrawer, setOtpDrawer] = useState(false);
  const [newOtpSent, setNewOtpSent] = useState(false);
  const [formData, setFormData] = useRecoilState(onboardingFormDataAtom);

  const [error, setError] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setotpError] = useState("");

  const utmSource = localStorage.getItem("UTM_SOURCE");
  const utm_campaign = localStorage.getItem("UTM_CAMPAIGN");
  const pocSource = localStorage.getItem("INVITE_POC");
  const flatmateInviteCode = localStorage.getItem("FLATMATE_INVITE_CODE");
  const utm_channel = localStorage.getItem("UTM_CHANNEL");
  const fbcl_id = localStorage.getItem("FBCL_ID");
  const queryStr = localStorage.getItem("QUERY_STR");
  const rf_code = localStorage.getItem("RF_CODE");

  const [isChecked, setIsChecked] = useState(true);
  const [linkDrawer, setLinkDrawer] = useState(false);
  const [currLink, setCurrLink] = useState("");

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    const updatedData = { ...formData };

    if (fbcl_id) {
      updatedData.fbcl_id = fbcl_id;
    }

    if (queryStr) {
      updatedData.queryStr = queryStr;
    }

    if (utmSource) {
      updatedData.source = utmSource;
    }
    if (pocSource) {
      updatedData.poc = pocSource;
    }
    if (utm_campaign) {
      updatedData.utm_campaign = utm_campaign;
    }

    if (flatmateInviteCode) {
      updatedData.flatmateInviteCode = flatmateInviteCode;
    }

    if (utm_channel) {
      updatedData.channel = utm_channel;
    }

    if (rf_code) {
      updatedData.referralCode = rf_code;
    }

    setFormData(updatedData);
  }, []);

  // useEffect(() => {
  //   if (formData?.phone) {
   
  //   }
  // }, [posthog, formData?.phone, formData?.first_name, formData?.last_name, utmSource, queryStr]);

  useEffect(() => {
    if (error || otpError || otp) {
      setError("");
      setotpError("");
    }
    if (otp.length === config.OTP_LENGTH) {
      handleVerifyOtp(otp);
    }
  }, [otp, newUser]);

  // useEffect(() => {
  //   if (
  //     isChecked &&
  //     isValidPhone(formData.phone) &&
  //     formData.first_name &&
  //     formData.last_name &&
  //     !otpDrawer
  //   )
  //     handleformSubmit();
  // }, [formData.phone]);

  const handleformSubmit = async () => {
    try {
      setError("");
      setLoading(true);
      if (!isValidPhone(formData.phone)) {
        setError("Please provide valid phone number");
        return;
      }
      posthog?.capture('GET_OTP_CLICKED');
      posthog?.identify(formData.phone, {
        first_name: formData.first_name,
        last_name: formData.last_name,
        phone: formData?.phone,
        utm: utmSource,
        queryStr: queryStr,
      });
      if (newUser) {
        const response = await signUpV2(formData);
        const token = response?.token;

        if (response.success) {
          posthog?.identify(formData.phone, {
            first_name: formData.first_name,
            last_name: formData.last_name,
            phone: formData?.phone,
            utm: utmSource,
            queryStr: queryStr,
            status: "NEW_USER",
          });
          setOtpDrawer(true);
        } else if (response.status === "USER_ALREADY_EXISTS") {
          posthog?.identify(formData.phone, {
            first_name: formData.first_name,
            last_name: formData.last_name,
            phone: formData?.phone,
            utm: utmSource,
            queryStr: queryStr,
            status: "ALREADY_EXISTS",
          });
          setError("You already registered with us, taking to login...");
          setTimeout(() => {
            setNewUser((prevState) => !prevState);
          }, 1500);
        } else {
          const error = new Error("OTP request failed");
          handleAndTrackError(error, {
            error: error.message,
            phone: formData?.phone,
            status: response.status,
          });
          setError("Failed to send OTP. Please try again.");
        }
      } else {
        const response = await sendOtpV2(formData);
        const token = response?.token;

        if (response.success) {
          setOtpDrawer(true);
        } else if (response.status === "NEW_USER") {
          setError("You are not registered with us, please signup!");
        } else {
          const error = new Error("OTP request failed");
          handleAndTrackError(error, {
            error: error.message,
            phone: formData.phone,
            status: response.status,
            message: "OTP request failed",
          });
          setError("Failed to send OTP. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error in handleformSubmit:", error);

      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

//   const handleVerifyOtp = async () => {
//     if (otp.length < config.OTP_LENGTH) {
//       throw new Error("Please enter the complete otp.");
//     }
//     try {
//       setVerifying(true);
//       const response = await verifyOtp({
//         otp: otp,
//       });

//       const platform =
//         navigator?.userAgentData?.platform ||
//         navigator.platform ||
//         localStorage.getItem("UTM_SOURCE");
//       trackConsent(
//         "Checkbox",
//         "Phone",
//         formData.phone,
//         platform,
//         CONSENT_MESSAGE
//       ).catch((error) => console.error(error));

//       console.log(response, "responseresponseresponseresponse");

// if (response.success) {
//   console.log("Response:", response);

//   const appUrl = "https://circlepe.club/download-app"; 
//   const appUrlt = "https://circlepe.club/home";

//   if (flatmateInviteCode) {
//     trackBtnClick("Verify OTP", "OTP Verification", "Invited Flatmate");
//     setTimeout(() => {
//       window.location.href = appUrl;
//     }, 1000);
//   } else if (response.isNew === true || response.isNew === "true") {
//     console.log("New User Detected");
//     trackBtnClick("Verify OTP", "OTP Verification", "New User");
//     setTimeout(() => {
//       window.location.href = appUrl;
//     }, 1000);
//   } else {
//     console.log("Existing User Detected");
//     trackBtnClick("Verify OTP", "OTP Verification", "Existing User");
//     setTimeout(() => {
//       window.location.href = appUrlt;
//     }, 1000);
//   }
// }
// else {
//         if (response.message === "Invalid OTP") {
//           trackBtnClick("Verify OTP", "OTP Verification", "Invalid OTP");
//           setotpError("Invalid OTP, please try again!");
//         } else {
//           const error = new Error(
//             response.message || "Unknown OTP verification error"
//           );

//           setotpError(error?.message);
//         }
//       }
//     } catch (error) {
//       console.error("Error in handleVerifyOtp:", error);

//       setotpError(error?.message || "Please try again after some time.");
//     } finally {
//       setVerifying(false);
//     }
//   };




 const handleVerifyOtp = async () => {
    if (otp.length < config.OTP_LENGTH) {
      throw new Error("Please enter the complete otp.");
    }
    try {
      setVerifying(true);
      const response = await verifyOtp({
        otp: otp,
      });

      const platform =
        navigator?.userAgentData?.platform ||
        navigator.platform ||
        localStorage.getItem("UTM_SOURCE");
      trackConsent(
        "Checkbox",
        "Phone",
        formData.phone,
        platform,
        CONSENT_MESSAGE
      ).catch((error) => console.error(error));

      console.log(response, "responseresponseresponseresponse");

      if (response.success) {
        if (flatmateInviteCode) {
          console.log("1");
          
          trackBtnClick("Verify OTP", "OTP Verification", "Invited Flatmate");
          // navigate("/redirect")
          navigate("/")
          
        } else if (response.isNew === true) {
           console.log("2");
          trackBtnClick("Verify OTP", "OTP Verification", "New User");
          // navigate("/redirect")
          navigate("/")
         
        } else {
           console.log("3");
          trackBtnClick("Verify OTP", "OTP Verification", "Existing User");
          navigate("/")
          
        }
      } else {
        if (response.message === "Invalid OTP") {
          trackBtnClick("Verify OTP", "OTP Verification", "Invalid OTP");
          setotpError("Invalid OTP, please try again!");
        } else {
          const error = new Error(
            response.message || "Unknown OTP verification error"
          );

          setotpError(error?.message);
        }
      }
    } catch (error) {
      console.error("Error in handleVerifyOtp:", error);

      setotpError(error?.message || "Please try again after some time.");
    } finally {
      setVerifying(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setOtp("");
      setVerifying(true);
      await handleformSubmit();
      setNewOtpSent(true);
    } catch (error) {
      console.error("Error in handleResendOtp:", error);

      setError(error?.message || "Please try again after some time.");
      setOtpDrawer(false);
    } finally {
      setVerifying(false);
    }
  };

  return (
    <Div100vh className="flex flex-col justify-start space-y-subheading-input p-10">
      <Header />
      <div className="flex flex-col space-y-subheading-input">
        <div className="flex flex-col space-y-heading-subheading">
          <motion.h1
            className="reveal-heading"
            initial="hidden"
            animate="visible"
            variants={headingVariants}
          >
            <span className="heading">Let's Get Started</span>
          </motion.h1>
          <motion.h1
            className="reveal-heading"
            initial="hidden"
            animate="visible"
            variants={headingVariants}
          >
            <span className="subheading">
              Journey to{" "}
              <span className="bg-shiny-gray bg-clip-text text-transparent font-bold">
                ZERO
              </span>{" "}
              security deposit begins here
            </span>
          </motion.h1>
        </div>
        <div className="flex flex-col gap-6">
          {newUser && (
            <div className="flex gap-2">
              <TextField
                name="first_name"
                label="First Name"
                value={formData?.first_name || ""}
                onChange={(val) =>
                  setFormData((prevData) => ({ ...prevData, first_name: val }))
                }
                type="text"
                required
              />
              <TextField
                name="last_name"
                label="Last Name"
                value={formData?.last_name || ""}
                onChange={(val) =>
                  setFormData((prevData) => ({ ...prevData, last_name: val }))
                }
                type="text"
                required
              />
            </div>
          )}
          <DynamicInputForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleformSubmit}
            formConfig={formConfig}
          />
          {newUser ? (
            <span className="text-xs text-[#666]">
              Already have an account?{" "}
              <button
                onClick={() => setNewUser((prevState) => !prevState)}
                className="text-[#1987FB]"
              >
                LogIn
              </button>
            </span>
          ) : (
            <span className="text-xs text-[#666]">
              New Here?{" "}
              <button
                onClick={() => setNewUser((prevState) => !prevState)}
                className="text-[#1987FB]"
              >
                SignUp
              </button>
            </span>
          )}
          {error && (
            <div className="w-full text-xs p-2 px-4 bg-rose-400/10 text-red-400 rounded-lg">
              {error}
            </div>
          )}
        </div>
      </div>

      <CustomDrawer isOpen={otpDrawer}>
        <div className="p-10">
          <GoBackButton />
          <div className="w-full text-left  ">
            <div className="heading mb-2 mt-12 ">Enter OTP</div>
            <div className="subheading font-light text-sm">
              Sent to{" "}
              <span className="font-light text-sm">
                {formData?.phone || "1234567890"}
              </span>{" "}
              <span
                onClick={() => setOtpDrawer(false)}
                className="underline font-medium text-[#ccc] text-sm"
              >
                EDIT
              </span>
            </div>
          </div>
          <div className="flex-grow overflow-auto mt-5 space-y-4">
            <OTPInput
              className="rounded-none"
              inputType="tel"
              value={otp}
              numInputs={config.OTP_LENGTH}
              onChange={setOtp}
              containerStyle={{
                display: "flex",
                justifyContent: "center",
              }}
              isInputNum={true}
              renderInput={(props) => (
                <input
                  {...props}
                  type="tel"
                  style={{ border: "1px solid #444", margin: "4px" }}
                  className="border-[#999] border w-10 h-12 text-center text-lg bg-transparent justify-around"
                />
              )}
              pattern="[1-9]{1}[0-9]{9}"
              shouldAutoFocus
            />
            {otpError && (
              <div className="w-full p-2 px-4 bg-red-400/10 text-red-400 rounded-lg">
                {otpError}
              </div>
            )}
            {!verifying && (
              <div className="w-full p-4">
                <div className="text-center subheading text-sm">
                  <span>
                    {newOtpSent
                      ? "New OTP has been sent, try again if not received?"
                      : "Didn't get the code?"}
                  </span>
                  <span> </span>
                  <span
                    onClick={() => handleResendOtp()}
                    className="font-semibold cursor-pointer text-[#ccc] text-sm"
                  >
                    Resend it
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="pt-6">
            {verifying ? (
              <Loader />
            ) : (
              <PrimaryButton
                text="Verify"
                handleClick={() => handleVerifyOtp()}
                disabled={otp?.length < config.OTP_LENGTH}
              />
            )}
          </div>
        </div>
      </CustomDrawer>

      <CustomDrawer isOpen={linkDrawer}>
        {/* <GoBackButton customBackSubmit={()=>setLinkDrawer(false)}/> */}

        <div className="h-full w-full absolute left-0 top-0">
          <iframe
            src={currLink}
            title="Website Frame"
            className="w-full h-full rounded-xl border border-[#444] my-4"
            allowFullScreen
          ></iframe>
        </div>
        <button
          onClick={() => setLinkDrawer(false)}
          className="absolute top-8 left-8 p-2 cursor-pointer hover:bg-slate-100 se:w-8 se:h-8 sm:h-11 sm:w-11 bg-white rounded-full flex flex-col justify-center items-center"
        >
          <ChevronLeftIcon className="size-112  text-black" />
        </button>
      </CustomDrawer>

      <div className="flex flex-col items-center gap-2 mt-10 h-full justify-end">
        {/* consent */}
        <div className="flex items-start space-x-2 text-2xs mb-4">
          {/* Checkbox */}
          <div
            className={`w-4 h-4 border-2 aspect-square mt-0.5 ${
              isChecked ? " bg-[#eee]" : "border-gray-400"
            } flex items-center justify-center cursor-pointer`}
            onClick={handleCheckboxChange}
          >
            {isChecked && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-black"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={3}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>

          {/* Label */}
          <label
            htmlFor="termsCheckbox"
            className=" text-[#999]  leading-relaxed"
          >
            {/* If you are chaning below consent, change this as well: CONSENT_MESSAGE */}
            I hereby agree to{" "}
            <a
              // href="/terms-and-conditions"
              // target="_blank"
              // rel="noopener noreferrer"
              onClick={() => {
                setCurrLink("https://www.circlepe.club/terms-conditions");
                setLinkDrawer(true);
              }}
              className="text-[#eee]"
            >
              CirclePe's T&Cs
            </a>{" "}
            and{" "}
            <a
              // href="/privacy-policy"
              // target="_blank"
              // rel="noopener noreferrer"
              onClick={() => {
                setCurrLink("https://www.circlepe.club/privacy-policy");
                setLinkDrawer(true);
              }}
              className="text-[#eee]"
            >
              Privacy Policy
            </a>{" "}
            & consent to be contacted by CirclePe and its partners via whatsapp,
            etc.
          </label>
        </div>
        {/* primary button */}
        {loading ? (
          <Loader />
        ) : (
          <PrimaryButton
            handleClick={() => handleformSubmit(formData)}
            text="Get OTP"
            className="w-full"
            disabled={isChecked ? false : true}
          />
        )}
      </div>
    </Div100vh>
  );
}
